import React, {Component} from 'react';
import t from 'tcomb-form';

import {FullString} from 'js/tcomb_types';

import Button from 'js/components/button';
import FormInput from 'js/components/form_input';
import FormTextarea from 'js/components/form_textarea';
import PinterestButton from 'js/components/pinterest_button';
import Section from 'js/components/section';
import ButtonGroup from 'js/components/button_group';

import './index.scss';

export default class PinterestPinForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            description: props.description,
            link: props.link
        };
    }

    isValid() {
        const {description} = this.state;
        const result = t.validate(description, FullString);
        return result.isValid();
    }

    render() {
        const {onCreate, onCancel} = this.props;
        const {description, link} = this.state;

        return (
            <Section header="Describe your Pin">
                <div className="pinterest-pin-form__description">
                    <FormTextarea
                        required
                        label="Description"
                        placeholder="Please describe this pin"
                        value={description}
                        onChange={e => this.setState({description: e.target.value})}
                    />
                </div>
                <FormInput
                    label="Link"
                    placeholder="Please enter the URL this pin will link to"
                    value={link}
                    onChange={e => this.setState({link: e.target.value})}
                />
                <ButtonGroup className="pinterest-pin-form__button-row">
                    <Button secondary mini back onClick={onCancel}>
                        Back
                    </Button>
                    <PinterestButton
                        onClick={() => onCreate(this.state)}
                        disabled={!this.isValid()}
                    >
                        Create a Pin
                    </PinterestButton>
                </ButtonGroup>
            </Section>
        );
    }
}



// WEBPACK FOOTER //
// ./components/pinterest_pin_form/index.js